import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { defaultProps } from './constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const counter = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.COUNTER> =>
	createModel({
		type: COMPONENT_TYPE.COUNTER,
		componentProps: {
			[UNIFORM_PROPS.counterType]: defaultProps.counterType,
			[UNIFORM_PROPS.counterDate]: defaultProps.counterDate,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {},
				},
			},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.counter.counterUnits]: defaultProps[OTHER_PROPS.counter.counterUnits],
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.COUNTER>;
